const isEmptyArray = (arr = []) => Array.isArray(arr) && !arr.length;

export default isEmptyArray;
